module.exports = __webpack_public_path__ + "static/img/auto-chartist-page.52d5754.svg";


//////////////////
// WEBPACK FOOTER
// ./static/fxView/images/auto-chartist-page.svg
// module id = fcoz
// module chunks = 4